module.exports = "<div class=\"date__info\">{{date | date:'dd MMMM yyyy'}}</div>\r\n<events #eventInfo ></events>"